import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

import activityAndMovementIntegrationsData from '../_data/activityAndMovementIntegrationsData';

const ActivityAndMovementIntegrations = (): JSX.Element => {
  return (
    <section
      className="z-10 py-20 text-brown-500"
      data-cy="activity-and-movement-integrations"
    >
      <LandingPageIntegrations
        description="activity_integrations_copy"
        logoColor="black"
        integrations={activityAndMovementIntegrationsData}
        title="activity_integrations_title"
        className="text-brown-500"
      />
    </section>
  );
};

export default ActivityAndMovementIntegrations;
